<div class="border-grey-light header-container">
  <div class="row gap-22 mobile-row">
    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>
  </div>

  <div class="row d-flex justify-content-end mg-top-8">
    <p>Passo 1 de 4</p>
  </div>
  <h5 class="mg-top-16 mg-bottom-16">Confirmação dos dados cadastrais</h5>
  <p class="p-text-grey mg-bottom-32">
    Revise e confirme se os dados complementares estão corretos e atualizados.
  </p>
</div>

<div class="padding-16">
  <div class="row mg-bottom-16">
    <h6 class="font-mobile">Dados da empresa</h6>
  </div>

  <div class="row d-flex justify-content-between">
    <p class="p-text-grey">Informe os dados da empresa</p>
    <p class="p-text-grey">* Campos obrigatórios</p>
  </div>
</div>

<form [formGroup]="companyForm">
  <div class="row">
    <div class="col-md-8">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Razão social</mat-label>
        <input
          matInput
          formControlName="companyName"
          type="text"
          class=""
          name="companyName"
          required
        />
        <mat-error
          *ngIf="
            companyFormControl.companyName.touched &&
            companyFormControl.companyName.errors?.required
          "
        >
          Razão Social obrigatória</mat-error
        >
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>CNPJ</mat-label>
        <input
          matInput
          formControlName="cnpj"
          type="text"
          mask="AA.AAA.AAA/AAAA-00"
          [clearIfNotMatch]="false"
          uppercase
          autocomplete="off"
          style="text-transform: uppercase"
          class=""
          name=""
          required
        />
        <mat-error
          *ngIf="
            companyFormControl.cnpj.touched &&
            companyFormControl.cnpj.errors?.required
          "
        >
          CNPJ obrigatório</mat-error
        >
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Setor de atuação</mat-label>
        <input
          matInput
          formControlName="businessSector"
          type="text"
          class=""
          name=""
        />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>E-mail</mat-label>
        <input
          matInput
          formControlName="email"
          pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$"
          type="email"
          class=""
          name=""
        />
        <mat-error
          *ngIf="
            companyFormControl.email.touched &&
            companyFormControl.email.errors?.required
          "
        >
          Email obrigatório
        </mat-error>
        <mat-error
          *ngIf="
            companyFormControl.email.touched &&
            companyFormControl.email.errors?.email
          "
        >
          Digite um endereço de email válido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Telefone</mat-label>
        <input
          matInput
          formControlName="phone"
          type="tel"
          class="js-control-phone-company"
          name=""
          mask="(00) 00000-0000"
        />
        <mat-error
          class="text-danger"
          *ngIf="
            companyFormControl.phone.touched &&
            companyFormControl.phone.errors?.required
          "
        >
          Número de telefone obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>CEP</mat-label>
        <input
          matInput
          (blur)="getCompanyCep(companyForm.value.postalCode)"
          type="tel"
          maxlength="10"
          mask="00000-000"
          placeholder="00000-000"
          formControlName="postalCode"
          type="text"
          name=""
          required
        />
        <mat-error
          class="text-danger"
          *ngIf="
            companyFormControl.postalCode.touched &&
            companyFormControl.postalCode.errors?.required
          "
        >
          CEP obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-6">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Endereço</mat-label>
        <input
          matInput
          formControlName="line1"
          type="text"
          class=""
          name=""
          required
        />
        <mat-error
          class="text-danger"
          *ngIf="
            companyFormControl.line1.touched &&
            companyFormControl.line1.errors?.required
          "
        >
          Endereço obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-2">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Número</mat-label>
        <input
          matInput
          formControlName="number"
          oninput="validity.valid||(value='');"
          type="number"
          class=""
          name=""
          required
        />
        <mat-error
          class="text-danger"
          *ngIf="
            companyFormControl.number.touched &&
            companyFormControl.number.errors?.required
          "
        >
          Número obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-2">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Bairro</mat-label>
        <input
          matInput
          formControlName="line3"
          type="text"
          class=""
          name=""
          required
        />
        <mat-error
          class="text-danger"
          *ngIf="
            companyFormControl.line3.touched &&
            companyFormControl.line3.errors?.required
          "
        >
          Bairro obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Complemento</mat-label>
        <input matInput formControlName="line2" type="text" class="" name="" />
      </mat-form-field>
    </div>

    <div class="col-md-3">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Cidade</mat-label>
        <input
          matInput
          formControlName="city"
          type="text"
          class=""
          name=""
          required
        />
        <mat-error
          class="text-danger"
          *ngIf="
            companyFormControl.city.touched &&
            companyFormControl.city.errors?.required
          "
        >
          Cidade obrigatória
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-3">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Estado</mat-label>
        <input
          matInput
          formControlName="state"
          type="text"
          class=""
          name=""
          required
        />
        <mat-error
          class="text-danger"
          *ngIf="
            companyFormControl.state.touched &&
            companyFormControl.state.errors?.required
          "
        >
          Estado obrigatório
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="padding-16">
    <div class="mg-bottom-16">
      <h6 class="font-mobile">Informações financeiras e patrimoniais</h6>
    </div>

    <div class="d-flex mg-bottom-32">
      <p class="p-text-grey">
        Se a empresa tiver menos de 12 meses de atividade, apresente a
        estimativa de faturamento.
      </p>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Faturamento anual</mat-label>
      <input
        matInput
        formControlName="annualBilling"
        type="text"
        class=""
        name=""
        required
        currencyMask
        min="1"
        [options]="{
          prefix: 'R$' + ' ',
          thousands: '.',
          decimal: ','
        }"
      />

      <mat-error
        class="text-danger"
        *ngIf="
          companyForm.controls['annualBilling'].touched &&
          companyForm.controls['annualBilling'].errors?.required
        "
      >
        Renda anual obrigatória
      </mat-error>
    </mat-form-field>
  </div>

  <div class="buttons border-grey-light">
    <div class="form-row">
      <div class="cols">
        <div class="form-group mb-0">
          <button
            [disabled]="companyForm.invalid"
            class="btn btn-block mb-3 btn-dark-primary-blue"
            type="button"
            (click)="register()"
          >
            Avançar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
